import clsx from "clsx";
import { ComponentPropsWithoutRef, ReactElement } from "react";

export const FieldGroup = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"div">): ReactElement => (
  <div
    data-slot="control"
    {...props}
    className={clsx(className, "space-y-8")}
  />
);
